/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Output } from "@angular/core";

@Component({
    selector: "app-google-login-button",
    imports: [],
    templateUrl: "./google-login-button.component.html",
    styleUrl: "./google-login-button.component.scss"
})
export class GoogleLoginButtonComponent {
  @Output() loginWithGoogleClick = new EventEmitter();

  loginWithGoogle() {
    this.loginWithGoogleClick.emit();
  }
}
